import { ILocationFilter } from '../locationfilter.model';
import { LocationFilterUtil } from '../../utilities/locationfilter.util';
export class LocationFilter implements ILocationFilter {
  searchTerm!: string;
  inactive?: boolean;
  critical!: boolean;
  warning!: boolean;
  working!: boolean;
  deInstalled!: boolean;
  selectedTypes: string[] = [];
  customer: string | null = null;
  countryOrRegionSelected: number | null = null;
  location: number[] = [];
  preselection = 0;

  // Getters delegating to utility functions
  get IsFiltering(): boolean {
    return LocationFilterUtil.isFiltering(this);
  }

  get IsOnlyFilteringCustomer(): boolean {
    return LocationFilterUtil.isOnlyFilteringCustomer(this);
  }

  get FilterSettingsCount(): number {
    return LocationFilterUtil.getFilterSettingsCount(this);
  }

  constructor(instance?: Partial<ILocationFilter>) {
    if (instance) {
      Object.assign(this, LocationFilterUtil.createFromInstance(instance));
    }
  }

  // Flange equipment type
  set Flange(active: boolean) {
    Object.assign(this, LocationFilterUtil.setFlange(this, active));
  }

  get Flange(): boolean {
    return LocationFilterUtil.getFlange(this);
  }

  // Tank equipment type
  set Tank(active: boolean) {
    Object.assign(this, LocationFilterUtil.setTank(this, active));
  }

  get Tank(): boolean {
    return LocationFilterUtil.getTank(this);
  }

  // Pipe equipment type
  set Pipe(active: boolean) {
    Object.assign(this, LocationFilterUtil.setPipe(this, active));
  }

  get Pipe(): boolean {
    return LocationFilterUtil.getPipe(this);
  }

  // Valve equipment type
  set Valve(active: boolean) {
    Object.assign(this, LocationFilterUtil.setValve(this, active));
  }

  get Valve(): boolean {
    return LocationFilterUtil.getValve(this);
  }

  // Steam Trap equipment type
  set SteamTrap(active: boolean) {
    Object.assign(this, LocationFilterUtil.setSteamTrap(this, active));
  }

  get SteamTrap(): boolean {
    return LocationFilterUtil.getSteamTrap(this);
  }

  // Rotating Equipment type
  set RotatingEquipment(active: boolean) {
    Object.assign(this, LocationFilterUtil.setRotatingEquipment(this, active));
  }

  get RotatingEquipment(): boolean {
    return LocationFilterUtil.getRotatingEquipment(this);
  }
}
